import request from './request'

const enterprisePracticeResourceApi = {
  saveEnterprisePracticeResource (data) {
    return request.post('/enterprisePracticeResource', data)
  },
  updateEnterprisePracticeResource (id, data) {
    return request.put('/enterprisePracticeResources/' + id, data)
  },
  deleteEnterprisePracticeResource (id) {
    return request.delete('/enterprisePracticeResources/' + id)
  },
  getEnterprisePracticeResource (id) {
    return request.get('/enterprisePracticeResources/' + id)
  },
  listEnterprisePracticeResource (params) {
    return request.get('/enterprisePracticeResources', { params })
  },
}

export default enterprisePracticeResourceApi
